/**
 * Тарифы после беты — на главной, после нескольких уроков: ученик уже
 * понял, за что платить. Ведёт на экран тарифов, где он выбирает тариф
 * (оплаты в бете нет — это замер готовности платить).
 */

import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PLAN_PRICES } from '@aptile/shared';

import { Button } from '../Button';
import { IconSparkles } from '../icons';

export function PlansCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <motion.section
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      aria-label={t('plansCard.title')}
      className="relative flex flex-col gap-4 overflow-hidden rounded-card p-5 shadow-card-lg sm:flex-row sm:items-center sm:p-6"
      style={{ background: 'linear-gradient(140deg, #6E5646 0%, #4A3B31 60%, #3A2E26 100%)' }}
    >
      <span aria-hidden="true" className="absolute -right-10 -top-12 h-44 w-44 rounded-full bg-[#E8B87A]/25 blur-2xl" />
      <span className="relative grid h-14 w-14 shrink-0 place-items-center rounded-2xl border border-white/30 bg-[#E8B87A]/25 text-[#E8B87A]">
        <IconSparkles size={28} stroke={1.8} aria-hidden="true" />
      </span>
      <div className="relative flex min-w-0 flex-1 flex-col gap-1">
        <h2 className="font-heading text-xl font-extrabold text-[#F7F4ED]">{t('plansCard.title')}</h2>
        <p className="text-[#F7F4ED]/85">{t('plansCard.text', { price: PLAN_PRICES.PRACTICE.month })}</p>
      </div>
      <Button onClick={() => navigate('/plans')}>{t('plansCard.go')}</Button>
    </motion.section>
  );
}
